export default "<p>\n  Sie haben die Quick Check Umwelt erfolgreich abgegeben und werden in wenigen Tagen über Ihre Benchmark informiert!\n</p>\n";